import React from 'react'

const FilterLabelItem = ({ label, onClick = null }) => {
  if (!label) return null

  return (
    <div
      onClick={onClick}
      style={{
        borderRadius: 4,
        backgroundColor: onClick ? '#0085FF' : '#6da2c0',
        display: 'block',
        margin: '0 3px',
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <div
        style={{
          color: 'white',
          textTransform: 'uppercase',
          fontSize: '14px',
          lineHeight: '16px',
          fontFamily: ' Roboto, sans-serif',
          minWidth: '75px',
          margin: '4px 15px',
          fontWeight: '700',
          textAlign: 'center',
          alignSelf: 'center',
        }}
      >
        {label}
      </div>
    </div>
  )
}

export const ChartHeader = ({
  selectedFilters,
  rewriteSelectedFiltersAction,
}) => {
  const filtersArray = Object.entries(selectedFilters);

  const renderFilterItems = () => {
    if (!filtersArray?.length) return null

    return filtersArray.map(([key, value]) => {
      let label = value
      let onClick = null
      if (value?.onClick)
        onClick = () => {
          value.onClick()
          rewriteSelectedFiltersAction({ key, value })
        }
      if (key === 'action') {
        if (!value) return null
        label = value.name
      } else {
        if (typeof value !== 'string') {
          label = key
        }
      }
      return (
        <FilterLabelItem
          key={value?.name || value}
          onClick={onClick}
          label={label}
        />
      )
    })
  }

  return (
    <div
      className={`ICMCharts__chart-header five-way`}
    >
      {renderFilterItems()}
    </div>
  )
}
